/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/no-array-index-key */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable indent */
import React from "react";
import { trackEvent } from "utils/Analytics";
import Button from "../elements/Button/index.js";

const CTASection = () => {
    const scrollToForm = () => {
        const formSection = document.getElementById('discovery-form');
        if (formSection) {
            formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        setTimeout(() => {
            const inputElement = document.getElementById('firstname');
            if (inputElement) {
                inputElement.focus({ preventScroll: true });
            }
        }, 600);
    };

    const handleDownload = () => {
        trackEvent({
            action: "pdf_download",
            category: "Marketing_Flyer",
            label: "EMS_Marketing_Flyer.pdf",
        });
    };

    return (
        <section className="w-full bg-theme-teal py-24 lg:py-24 lg:mb-24 mb-12">
            <div className="max-w-3xl mx-auto px-6 text-center">
                <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-6">
                    Smarter EMS starts now.
                </h2>
                <p className="text-white/90 text-lg md:text-xl font-light leading-relaxed mb-12">
                    See exactly how Nube iO performs across your portfolio — book a
                    discovery session or download the product sheet.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center w-full max-w-lg mx-auto">
                    <Button
                        onClick={scrollToForm}
                        className="flex-1 px-8 py-4 bg-theme-yellow hover:bg-theme-yellow/90 text-black font-bold rounded-lg transition-colors duration-300 flex items-center justify-center gap-2 text-center whitespace-nowrap"
                    >
                        Book a discovery session →
                    </Button>

                    <a
                        href="Docs/EMS_Marketing_Flyer_0326_HighRes.pdf"
                        type="link"
                        className="w-full px-8 py-4 border border-white/30 hover:bg-white/10 text-white font-medium rounded-lg transition-colors duration-300 text-center whitespace-nowrap"
                        download="EMS_Marketing_Flyer.pdf"
                        onClick={handleDownload}
                    >
                        Download the product sheet
                    </a>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
